var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "cfe77cf2-5f19-4a5d-87e2-4c68576de153"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "b7054cbe-c460-477a-8d4b-65f2dfd9d808"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.12 0 0 14.12 538.83 538.83)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.24 16.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-33.75, -66.08)",
    d: "M 45.945 62.984 L 31.312 78.445 C 30.208000000000002 79.60499999999999 28.386000000000003 79.66099999999999 27.226 78.55499999999999 L 21.648 73.30999999999999 C 20.491 72.20499999999998 20.434 70.32699999999998 21.538 69.16799999999999 L 36.17 53.706 C 37.228 52.597 38.978 52.53 40.146 53.491 L 44.491 49.235 L 41.915 46.804 C 39.762 44.705 36.336999999999996 44.705 34.403999999999996 46.804 L 14.523999999999997 67.732 C 12.590999999999998 69.831 12.758999999999997 73.2 14.964999999999998 75.298 L 25.568999999999996 85.348 C 27.775999999999996 87.447 31.146999999999995 87.447 33.132999999999996 85.348 L 52.955 64.42 C 54.945 62.321 54.725 58.952 52.571 56.854 L 50.224 54.64 L 45.875 58.901 C 46.984 60.011 47.033 61.841 45.945 62.984 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 16.24 -16.09)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-66.23, -33.91)",
    d: "M 85.043 24.715 L 74.385 14.609 C 72.232 12.565999999999999 68.808 12.565999999999999 66.87400000000001 14.609 L 46.995 35.595 C 45.062 37.638 45.229 41.004999999999995 47.436 43.104 L 49.122 44.702 L 53.572 40.338 C 53.013000000000005 39.259 53.128 37.897 54.007000000000005 36.975 L 68.64 21.568 C 69.747 20.408 71.623 20.353 72.784 21.458000000000002 L 78.305 26.703000000000003 C 79.46600000000001 27.808000000000003 79.519 29.686000000000003 78.415 30.845000000000002 L 63.838 46.252 C 62.732 47.411 60.856 47.466 59.694 46.362 L 59.173 45.873000000000005 L 54.839 50.121 L 58.039 53.153000000000006 C 60.245000000000005 55.25200000000001 63.616 55.25200000000001 65.602 53.209 L 85.42500000000001 32.225 C 87.417 30.183 87.249 26.758 85.043 24.715 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.33 -0.33)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-5.17,-0.44 0.56,4.97 5.17,0.45 -0.54,-4.97 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.48 9.71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-39.52, -59.71)",
    d: "M 34.032 63.705 L 35.318 65.01599999999999 C 36.483 66.207 38.396 66.228 39.586999999999996 65.05999999999999 L 45.876999999999995 58.90199999999999 C 45.858 58.884999999999984 45.85099999999999 58.859999999999985 45.834999999999994 58.84299999999999 L 40.31399999999999 53.59599999999999 C 40.263999999999996 53.54799999999999 40.199999999999996 53.53499999999999 40.14699999999999 53.49199999999999 L 34.07799999999999 59.43699999999999 C 32.887 60.603 32.864 62.515 34.032 63.705 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.81 4.07)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-45.19, -54.07)",
    d: "M 40.146 53.491 C 40.199 53.535 40.264 53.548 40.313 53.595 L 45.834 58.842 C 45.85 58.859 45.857000000000006 58.884 45.876000000000005 58.900999999999996 L 50.22500000000001 54.63999999999999 L 44.49100000000001 49.23499999999999 L 40.146 53.491 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.28 -10.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-60.28, -39.25)",
    d: "M 59.174 45.874 L 66.079 39.113 C 67.27 37.946 67.28899999999999 36.035 66.125 34.844 L 64.839 33.533 C 63.671 32.34 61.760999999999996 32.322 60.57 33.488 L 53.572 40.339 C 53.718 40.619 53.877 40.891 54.117000000000004 41.117 L 59.174 45.874 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.15 -4.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-54.15, -45.23)",
    d: "M 54.117 41.116 C 53.876999999999995 40.89 53.717999999999996 40.618 53.571999999999996 40.338 L 49.12199999999999 44.702 L 54.83999999999999 50.122 L 59.17399999999999 45.874 L 54.117 41.116 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.1b8b209a986593281aa981e7b611f701.svg";
export { ForwardRef as ReactComponent };